export default "/fonts/poppins-v9-latin-700.woff?f4b97733bc584fb5cfba39be5aa76342";